import { createContext, useState, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AudienceChart } from "../services/AudienceService";
import { ValidAccessTokenLocalStorage, getAccessTokenLocalStorage } from "../context/utils"
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import {
  AudienceMerge,
  AudienceMinute,
  doAudienceHandleReturnWithWError401, doAudienceHandleReturnWithWError96
} from "../context/AudienceContextUtils";
import { NetworkAlertContext } from '../context/NetworkAlertContext';
import { usePreference } from "../context/usePreference";
import { DatePraca } from "../services/DateService";
import PropTypes from 'prop-types';

export const ChartContext = createContext();

const ChartProvider = ({ children }) => {
  const u = usePreference();
  const { userAuthenticated, setUserAuthenticated, setUserMenssageApi } = useContext(UserPreferenceContext);
  const { setShowError, setInfoSpan, setShowInfo, setInfoError } = useContext(NetworkAlertContext);
  const [audience, setAudience] = useState([]);
  const [audienceChart] = useState([]);
  const [audienceFirstTable, setAudienceFirstTable] = useState([]);
  const [audienceMediaFirstTable] = useState([]);
  const [AudienceChartFirstTable] = useState([]);
  const { t: translateText } = useTranslation();
  const [qtdMinutos] = useState(61);
  const [lastMinute, setLastMinute] = useState();
  const [lastAudience, setLastAudience] = useState();
  const [lastThirtyAudience, setLastThirtyAudience] = useState();
  const [lastThirtyAudiencePie, setLastThirtyAudiencePie] = useState();

  function hideShowInfo() {
    setTimeout(() => setShowInfo(false), 3000);
  }

  async function doAudienceChart() {
    setInfoSpan(translateText('network.loadingData'));
    setShowInfo(true);
    let token = getAccessTokenLocalStorage();

    if (ValidAccessTokenLocalStorage()) {
      await AudienceChart(token, qtdMinutos).then(res => {
        const dadosRating = res?.data?.ListDadosRating;
        if (res.data.CodErro !== 0) {
          throw new Error(JSON.stringify(res));
        }
        doAudienceHandleReturnSuccess(dadosRating);

        const lastHourMinute = dadosRating[0][1];
        u.setHoraFinCalendar(lastHourMinute);
        hideShowInfo();
      })
        .catch(err => {
          let errorData;
          try {
            errorData = JSON.parse(err.message);
          } catch (e) {
            return null;
          }
          doAudienceHandleReturnWithWError({ "response": errorData });
        });
      if (u.userPreference.UserAutoScroll)
        await DatePraca(token, u.userPreference.Country.CountryID, u.userPreference.Praca.Id).then(res => {
          if (res.status === 200) {
            u.userPreference.Horario = res.data;
          }
        });
    }
  };

  const objMemoProvider = useMemo(
    () => ({
      lastThirtyAudiencePie,
      lastThirtyAudience,
      audience,
      audienceChart,
      audienceFirstTable,
      audienceMediaFirstTable,
      AudienceChartFirstTable,
      lastMinute,
      doAudienceChart,
      setAudience,
      lastAudience,
      qtdMinutos
    }
    ),
    [lastThirtyAudiencePie,
      lastThirtyAudience,
      audience,


      audienceChart,
      audienceFirstTable,
      audienceMediaFirstTable,
      AudienceChartFirstTable,
      lastMinute,
      lastAudience,
      doAudienceChart,
      qtdMinutos
    ]
  );
  return (
    <div id='divAudienceContext'>
      <ChartContext.Provider
        value={objMemoProvider}>
        {children}
      </ChartContext.Provider>
    </div>
  );



  function doAudienceHandleReturnSuccess(listDadosRating) {
    if (listDadosRating != null) {
      doAudienceLoad(listDadosRating);
      setShowInfo(false);
    }
  }
  function doAudienceLoad(listDadosRating) {
    AudienceMerge(listDadosRating, setLastMinute, setAudience, setLastThirtyAudiencePie, setLastThirtyAudience, setLastAudience);
    AudienceMinute(listDadosRating, setAudienceFirstTable);
  }
  function doAudienceHandleReturnWithWError(resultError) {
    const dataResponse = resultError?.response?.data;
    doAudienceHandleReturnWithWError401(resultError, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
    doAudienceHandleReturnWithWError96(dataResponse, setAudience, setAudienceFirstTable, setShowError, setInfoError);
    doAudienceHandleReturnWithWError98(dataResponse);
  }
  function doAudienceHandleReturnWithWError98(dataResponse) {
    if (Number(dataResponse.CodErro) === 98) {
      const msgErro = dataResponse?.MsgErro;
      setInfoSpan(translateText(msgErro));
      doAudienceLoad(dataResponse?.ListDadosRating);
      hideShowInfo();
    }
  }

}

ChartProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default ChartProvider;